import { render, staticRenderFns } from "./cuccToAuthTest.vue?vue&type=template&id=0f5d38a9&"
import script from "./cuccToAuthTest.vue?vue&type=script&lang=js&"
export * from "./cuccToAuthTest.vue?vue&type=script&lang=js&"
import style0 from "./cuccToAuthTest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports